"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _detail = _interopRequireDefault(require("./detail.vue"));
var _vuex = require("vuex");
var _createNamespacedHelp = (0, _vuex.createNamespacedHelpers)('picture'),
  mapState = _createNamespacedHelp.mapState,
  mapMutations = _createNamespacedHelp.mapMutations,
  mapActions = _createNamespacedHelp.mapActions;
var _default = {
  components: {
    Detail: _detail.default
  },
  provide: function provide() {
    return {
      uploader: this
    };
  },
  props: {
    /**
     * [visible description]
     * @type {Object}
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 执行的上传方法
     * @type {Object}
     */
    limit: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      selectClassify: '',
      selectPicture: {},
      dialogVisible: false
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: (0, _objectSpread2.default)({}, mapState(['classify', 'pictures', 'classifyInfo'])),
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {
    selectClassify: function selectClassify(value) {
      var classify = this.classify;
      for (var index in classify) {
        var item = classify[index];
        if (item.id == value) {
          this.setClassifyInfo(item);
        }
      }
      this.handlePictures({
        id: value,
        current: 1,
        pageSize: 15
      });
    }
  },
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.handleClassify();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, mapMutations(['setClassifyInfo'])), mapActions(['handleClassify', 'handlePictures'])), {}, {
    /**
     * 处理点击事件
     * @return {[type]} [description]
     */
    handleClick: function handleClick() {
      this.dialogVisible = true;
    },
    /**
     * 处理关闭事件
     * @return {[type]} [description]
     */
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 处理确认事件
     * @return {[type]} [description]
     */
    handleConfirm: function handleConfirm() {
      this.dialogVisible = false;
      this.$emit('confirm', this.selectPicture);
    }
  }),
  render: function render(h) {
    var dialogVisible = this.dialogVisible,
      handleClick = this.handleClick,
      handleClose = this.handleClose,
      handleConfirm = this.handleConfirm;
    //判断插槽是否存在DOM结构，如果存在则获取后放入upload目录
    var trigger = this.$slots.trigger || this.$slots.default;

    //设置上传样式
    var defaultData = {
      class: 'photo-solt',
      on: {
        click: handleClick
      }
    };
    var dialogData = {
      props: {
        visible: dialogVisible,
        title: '选择图片',
        'before-close': handleClose,
        width: '1077px',
        'destroy-on-close': true
      }
    };
    return h("div", {
      "class": "photo-dialog"
    }, [h("div", (0, _babelHelperVueJsxMergeProps.default)([{}, defaultData]), [trigger]), h("el-dialog", (0, _babelHelperVueJsxMergeProps.default)([{}, dialogData]), [h(_detail.default), h("template", {
      "slot": "footer"
    }, [h("el-button", {
      "on": {
        "click": handleClose
      }
    }, ["\u53D6 \u6D88"]), h("el-button", {
      "attrs": {
        "type": "primary"
      },
      "on": {
        "click": handleConfirm
      }
    }, ["\u786E \u5B9A"])])])]);
  }
};
exports.default = _default;